import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  inputContainer: {
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    width: '70%',
  },
  pimSuccessChip: {
    height: 20,
    fontSize: '0.75rem',
    marginRight: 4,
    borderColor: theme.palette.success.main,
  },
  pimWarningChip: {
    height: 20,
    fontSize: '0.75rem',
    marginLeft: 3,
    borderColor: theme.palette.warning.main,
  },
  pimSuccessLabel: {
    color: `${theme.palette.success.main} !important`,
    fontWeight: 'bold',
  },
  pimWarningLabel: {
    color: `${theme.palette.warning.main} !important`,
    fontWeight: 'bold',
  },
  pimSuccessIcon: {
    fontSize: '14px !important',
    color: `${theme.palette.success.main} !important`,
    marginLeft: '6px !important',
  },
  pimWarningIcon: {
    fontSize: '14px !important',
    color: `${theme.palette.warning.main} !important`,
    marginLeft: '6px !important',
  },
  pimSecondaryChip: {
    borderColor: theme.palette.secondary.main,
    marginLeft: 8,
    fontSize: 12,
    height: 18,
    minWidth: 0,
  },
  pimLoadingChip: {
    height: 20,
    fontSize: '0.75rem',
    marginRight: 4,
  },
  checkAgainButton: {
    whiteSpace: 'nowrap',
  },
}));
